import React, { useState, useEffect, useCallback } from "react";
import {  Table, Input } from "antd";
import { PageHeader } from '@ant-design/pro-layout';
import {useAxios} from "../../hooks/hooks";
import {cancelTokenSource} from "../../hooks/hooks";

// TODO: make dynamic based on flags in DB
const flag_to_id = {
  negligible: 2,
  low: 3,
  medium: 4,
  high: 5,
  unknown: 6,
};

const id_to_flag = {
  2: "negligible",
  3: "low",
  4: "medium",
  5: "high",
  6: "unknown",
};

// TODO: make dynamic based on materials in DB
const defaultDataSource = [
  {
    key: 0,
    ids_removedrisk: {
      negligible: null,
      low: null,
      medium: null,
      high: null,
      unknown: null,
    },
    id_material: 1,
    material: "Asbestos",
    negligible: 0,
    low: 0,
    medium: 0,
    high: 0,
    unknown: 0,
  },
  {
    key: 1,
    ids_removedrisk: {
      negligible: null,
      low: null,
      medium: null,
      high: null,
      unknown: null,
    },
    id_material: 2,
    material: "Lead-Based Paint System",
    negligible: 0,
    low: 0,
    medium: 0,
    high: 0,
    unknown: 0,
  },
  {
    key: 2,
    ids_removedrisk: {
      negligible: null,
      low: null,
      medium: null,
      high: null,
      unknown: null,
    },
    id_material: 4,
    material: "SMF",
    negligible: 0,
    low: 0,
    medium: 0,
    high: 0,
    unknown: 0,
  },
  {
    key: 3,
    ids_removedrisk: {
      negligible: null,
      low: null,
      medium: null,
      high: null,
      unknown: null,
    },
    id_material: 5,
    material: "PCB",
    negligible: 0,
    low: 0,
    medium: 0,
    high: 0,
    unknown: 0,
  },
  {
    key: 4,
    ids_removedrisk: {
      negligible: null,
      low: null,
      medium: null,
      high: null,
      unknown: null,
    },
    id_material: 6,
    material: "ODS",
    negligible: 0,
    low: 0,
    medium: 0,
    high: 0,
    unknown: 0,
  },
  {
    key: 5,
    ids_removedrisk: {
      negligible: null,
      low: null,
      medium: null,
      high: null,
      unknown: null,
    },
    id_material: 8,
    material: "Asbestos Containing Dust",
    negligible: 0,
    low: 0,
    medium: 0,
    high: 0,
    unknown: 0,
  },
  {
    key: 6,
    ids_removedrisk: {
      negligible: null,
      low: null,
      medium: null,
      high: null,
      unknown: null,
    },
    id_material: 3,
    material: "Lead Containing Dust",
    negligible: 0,
    low: 0,
    medium: 0,
    high: 0,
    unknown: 0,
  },
  {
    key: 7,
    ids_removedrisk: {
      negligible: null,
      low: null,
      medium: null,
      high: null,
      unknown: null,
    },
    id_material: 7,
    material: "Inaccessible Areas",
    negligible: 0,
    low: 0,
    medium: 0,
    high: 0,
    unknown: 0,
  },
];

const InputTableCell = (props) => {
  return (
    <>
      <Input
        type="number"
        value={props.value || 0}
        min={0}
        onChange={props.onChange}
        style={
          props.value === 0 ||
          props.value === "0" ||
          props.value === "" ||
          props.value === undefined
            ? { backgroundColor: "white", fontWeight: "normal" }
            : { backgroundColor: props.backgroundColor, fontWeight: "bold" }
        }
      />
    </>
  );
};

const InputTableComponent = (props) => {
  const axios = useAxios();
  const source = cancelTokenSource;
  const [error, setError] = useState("");
  const [removedRisks, setRemovedRisks] = useState([]);
  const [dataSource, setDataSource] = useState([...defaultDataSource]);

  const getRemovedRisks = useCallback(async () => {
    var rows = [];
    var url = `removed-risks?filter[id_project]=${props.currentProject}`;
    const response = await axios.current.get(url);
    rows = response.data.rows;
    if (rows.error) {
      setError(JSON.stringify(rows.error));
      return null;
    }
    setRemovedRisks(rows);
  }, [props.currentProject]);

  // Update source, then call update DB

  const updateRemovedRisk = useCallback(
    async (record, flag, value) => {
      const key = record.key;
      const id_removedrisk = record.ids_removedrisk[flag];
      const id_material = record.id_material;

      // Update state
      setDataSource((oldDataSource) => {
        const newRemovedRisks = oldDataSource.map((x) => ({ ...x }));
        newRemovedRisks[key][flag] = value;
        return newRemovedRisks;
      });

      // Update database entry
      const id_flag = flag_to_id[flag];
      if (id_removedrisk === null) {
        // Need to create new entry in database
        await axios.current.post(
          props.endpoint.namespace.code,
          {
            id_project: props.currentProject,
            id_material: id_material,
            id_flag: id_flag,
            quantity_removed_risk: value,
          },
          { cancelToken: cancelTokenSource.token }
        );
        getRemovedRisks();
      } else {
        await axios.current.put(
          props.endpoint.namespace.code + "/" + id_removedrisk,
          {
            id_project: props.currentProject,
            id_material: id_material,
            id_flag: id_flag,
            quantity_removed_risk: value,
          },
          { cancelToken: cancelTokenSource.token }
        );
      }
    },
    [
      props.currentProject,
      props.endpoint.namespace.code,
      cancelTokenSource.token,
      getRemovedRisks,
    ]
  );

  useEffect(() => {
    getRemovedRisks();
  }, [getRemovedRisks]);

  useEffect(() => {
    const newDataSource = defaultDataSource.map((x) => ({ ...x }));
    removedRisks.forEach((r) => {
      const obj = newDataSource.find(
        (obj) => obj.id_material === r.id_material
      );
      obj[id_to_flag[r.id_flag]] = r.quantity_removed_risk;
      obj.ids_removedrisk[id_to_flag[r.id_flag]] = r.id_removedrisk;
    });
    setDataSource(newDataSource);
  }, [removedRisks]);

  return (
    <>
      <PageHeader
        title={
          <>
            <span>{props.title}</span>&nbsp;
          </>
        }
        style={{ padding: 0, paddingBottom: 16 }}
        extra={[]}
      />
      <Table
        pagination={false}
        columns={[
          {
            title: (
              <div>
                <div style={{ "textAlign": "right" }}>Risk</div>
                <div>Material</div>
              </div>
            ),
            dataIndex: "material",
            key: "material",
          },

          {
            title: "Negligible",
            dataIndex: "negligible",
            key: "negligible",
            render: (key, record) => (
              <InputTableCell
                backgroundColor={"#CCCCCC"}
                value={record["negligible"]}
                onChange={async (e) => {
                  updateRemovedRisk(record, "negligible", e.target.value);
                }}
              />
            ),
          },
          {
            title: "Low",
            dataIndex: "low",
            key: "low",
            render: (key, record) => (
              <InputTableCell
                backgroundColor={"#00FF00"}
                value={record["low"]}
                onChange={async (e) => {
                  updateRemovedRisk(record, "low", e.target.value);
                }}
              />
            ),
          },
          {
            title: "Medium",
            dataIndex: "medium",
            key: "medium",
            render: (key, record) => (
              <InputTableCell
                backgroundColor={"#FFCC00"}
                value={record["medium"]}
                onChange={async (e) => {
                  updateRemovedRisk(record, "medium", e.target.value);
                }}
              />
            ),
          },
          {
            title: "High",
            dataIndex: "high",
            key: "high",
            render: (key, record) => (
              <InputTableCell
                backgroundColor={"#FF0000"}
                value={record["high"]}
                onChange={async (e) => {
                  updateRemovedRisk(record, "high", e.target.value);
                }}
              />
            ),
          },
          {
            title: "Unknown",
            dataIndex: "unknown",
            key: "unknown",
            render: (key, record) => (
              <InputTableCell
                backgroundColor={"#FF6600"}
                value={record["unknown"]}
                onChange={async (e) => {
                  updateRemovedRisk(record, "unknown", e.target.value);
                }}
              />
            ),
          },
        ]}
        dataSource={dataSource}
      ></Table>
    </>
  );
};

export default InputTableComponent;
